import { formatPrice } from '../utils/formatPrice.js';

// Informational only — V1 is a digital menu, not an ordering flow (spec
// §6), so this lists what's available and what it costs rather than
// offering a selectable add-to-cart control. The circle/square marker is a
// non-interactive visual echo of "pick one" vs "pick any" — redundant with
// the "Choose one/multiple" text on purpose, since shape/color must never
// be the only signal (WCAG 1.4.1).
export function OptionGroup({ option, currency, itemPrice }) {
  const markerShape = option.selectionType === 'MULTI' ? 'rm-option-marker--square' : 'rm-option-marker--circle';
  const showFinalPrices = option.selectionType === 'SINGLE' && option.isRequired;

  return (
    <div className="rm-option-group">
      <div className="rm-option-group__header">
        <span className="rm-option-group__name">{option.name}</span>
        <span className={`rm-badge ${option.isRequired ? 'rm-badge--required' : 'rm-badge--optional'}`}>
          {option.isRequired ? 'Required' : 'Optional'}
        </span>
        <span className="rm-option-group__hint">{option.selectionType === 'MULTI' ? 'Choose multiple' : 'Choose one'}</span>
      </div>
      <div className="rm-option-group__values">
        {option.values.map((value, i) => (
          <div key={i} className={`rm-option-value${value.isAvailable === false ? ' rm-option-value--unavailable' : ''}`}>
            <span className="rm-option-value__label">
              <span
                className={`rm-option-marker ${markerShape}${value.isDefault ? ' rm-option-marker--default' : ''}`}
                aria-hidden="true"
              />
              {value.label}
              {value.isDefault && <span className="rm-option-value__default-tag">Default</span>}
            </span>
            {showFinalPrices && itemPrice !== null && itemPrice !== undefined ? (
              <span className="rm-option-value__price">
                {formatPrice(Number(itemPrice) + Number(value.priceDelta ?? 0), currency)}
              </span>
            ) : !showFinalPrices && value.priceDelta ? (
              <span className="rm-option-value__price">
                {value.priceDelta > 0 ? '+' : ''}
                {formatPrice(value.priceDelta, currency)}
              </span>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
